
import { Select, Option, Checkbox, Button } from "element-ui"
import { throttle } from "lodash"
import { AUTH_TYPE, SmsSendTypeEnum } from "@/constants/auth"
import { sendSmsVerifyCode, getLoginTerms } from "@/api/authentication"
import { getLocalStorageAccountInfo, showGlobalMessage, getDeviceId } from "@/utils/utils"
import { validatePassword, validatePhoneNumber } from "@/utils/auth"
import { COUNTRY_CODE } from "@/constants/common"
export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Checkbox.name]: Checkbox
  },
  props: {
    type: {
      type: String,
      default: "login"
    },
    handleLogin: {
      type: Function,
      default: () => {}
    },
    handleSignUp: {
      type: Function,
      default: () => {}
    },
    handleResetPassword: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      AUTH_TYPE,
      countryCode: "+65",
      options: COUNTRY_CODE,
      phone: "",
      authCode: "",
      password: "",
      placeholderPhone: this.$t("auth.enterPhoneNumber"),
      placeholderSms: this.$t("auth.smsCode"),
      pwdType: "password",
      showPwd: false,
      eyes: "eyesClose",
      smsWait: 0,
      disableSend: false,
      timmer: null,
      smsLogin: false,
      notificationChecked: false,
      protocalUrl: {
        purposesProtocolUrl: "https://coldstorage.com.sg/en/d/cs7htgJar1.html",
        userProtocolUrl: "https://coldstorage.com.sg/en/d/cs7htgJar1.html",
        privacyProtocol: "https://coldstorage.com.sg/en/d/cs7htgJar1.html",
        protocolUrl: "https://coldstorage.com.sg/en/d/pDjHuIvwCahmJYB.html",
        picsProtocolUrl: "https://coldstorage.com.sg/en/d/YyV7SscAxi.html"
      },
      lang: this.$i18n.locale,
      smsType: "",
      title: ""
    }
  },
  computed: {
    pwdTitle() {
      return this.type === AUTH_TYPE.LOGIN ? this.$t("auth.password") : this.$t("auth.setNewPassword")
    },
    phoneWithCountryCode() {
      return this.countryCode + " " + this.phone
    }
  },
  watch: {},
  created() {},
  mounted() {
    this.smsLogin = false
    if (this.type === AUTH_TYPE.SIGN_UP) {
      // getLoginTerms().then(res => {
      //   this.protocalUrl = res.data
      // })
    }
    if (this.type === AUTH_TYPE.CHANGE_PASSWORD) {
      const accountInfo = getLocalStorageAccountInfo()
      this.countryCode = accountInfo.areaCode
      this.phone = accountInfo.phone
    }
    this.initData()
  },
  beforeDestroy() {
    clearInterval(this.timmer)
  },
  methods: {
    initData() {
      let title = ""
      let smsType = ""
      switch (this.type) {
        case AUTH_TYPE.LOGIN:
          title = this.$t("auth.login")
          smsType = SmsSendTypeEnum.login
          break
        case AUTH_TYPE.SIGN_UP:
          title = this.$t("auth.signUp")
          smsType = SmsSendTypeEnum.login
          break
        case AUTH_TYPE.CHANGE_PASSWORD:
          title = this.$t("auth.changePwd")
          smsType = SmsSendTypeEnum.resetPassword
          break
        case AUTH_TYPE.FORGOT_PASSWORD:
          title = this.$t("auth.forgotPwd")
          smsType = SmsSendTypeEnum.resetPassword
          break
        default:
          title = ""
      }
      this.title = title
      this.smsType = smsType
    },
    handleShowPwd() {
      this.showPwd = !this.showPwd
      this.pwdType = this.showPwd ? "text" : "password"
      this.eyes = this.showPwd ? "eyes" : "eyesClose"
    },
    handleSwitchLoginType() {
      this.smsLogin = !this.smsLogin
      this.password = ""
      this.authCode = ""
    },
    getRiskControlParams() {
      return {
        deviceId: getDeviceId()
      }
    },
    handleSmsSend: throttle(
      async function (e) {
        e.preventDefault()
        if (!validatePhoneNumber(this.phoneWithCountryCode)) {
          this.notifyInvalidPhoneNumber()
          return
        }
        try {
          e.preventDefault()
          const _this = this
          await grecaptcha.ready(function () {
            grecaptcha
              .execute("6Lc2BMMqAAAAAHCb0v1sJNO5lesaGtjruz7d1r1X", { action: "submit" })
              .then(async function (token) {
                await sendSmsVerifyCode({
                  phone: _this.phoneWithCountryCode,
                  smsType: _this.smsType,
                  loginChannel: 3,
                  reCaptchaToken: token,
                  ..._this.getRiskControlParams()
                })
                _this.smsWait = 60
                _this.timmer = setInterval(() => {
                  _this.smsWait = _this.smsWait - 1
                  if (_this.smsWait === 0) {
                    clearInterval(_this.timmer)
                    _this.smsWait = 0
                  }
                }, 1000)
              })
          })
          // await sendSmsVerifyCode({
          //   phone: this.phoneWithCountryCode,
          //   smsType: this.smsType,
          //   loginChannel: 3,
          //   ...this.getRiskControlParams()
          // })
          // this.smsWait = 60
          // this.timmer = setInterval(() => {
          //   this.smsWait = this.smsWait - 1
          //   if (this.smsWait === 0) {
          //     clearInterval(this.timmer)
          //     this.smsWait = 0
          //   }
          // }, 1000)
        } catch (error) {
          console.error(error)

          // this.$message({
          //   message: error.result,
          //   type: "error"
          // })
        }
      },
      3000,
      { trailing: false } // 防止触发2次
    ),
    handleLoginWithSMS() {
      this.smsLogin = true
    },
    notifyInvalidPhoneNumber() {
      this.showMessage(this.$t("auth.invalidPhoneNumber"))
    },
    handleEnter() {
      if (this.type === AUTH_TYPE.LOGIN) {
        this.handleClickLogin()
      } else if (this.type === AUTH_TYPE.CHANGE_PASSWORD) {
        this.handleClickResetPassword()
      } else if (this.type === AUTH_TYPE.FORGOT_PASSWORD) {
        this.handleClickResetPassword()
      } else if (this.type === AUTH_TYPE.SIGN_UP) {
        this.handleClickSignUp()
      }
    },
    handleClickLogin() {
      if (!validatePhoneNumber(this.phoneWithCountryCode)) {
        this.notifyInvalidPhoneNumber()
        return
      }
      if (this.smsLogin) {
        if (!this.authCode) {
          this.showMessage(this.$t("auth.enterSMSCode"))
          return
        }
      } else if (!this.password) {
        this.showMessage(this.$t("auth.enterYourPassword"))
        return
      }
      this.$emit("handleLogin", {
        phoneNumber: this.phoneWithCountryCode,
        password: this.password,
        code: this.authCode,
        notificationChecked: this.notificationChecked
      })
    },
    handleClickSignUp() {
      if (!validatePhoneNumber(this.phoneWithCountryCode)) {
        this.notifyInvalidPhoneNumber()
        return
      }
      if (!this.authCode) {
        this.showMessage(this.$t("auth.enterSMSCode"))
        return
      }
      this.$emit("handleSignUp", {
        phoneNumber: this.phoneWithCountryCode,
        code: this.authCode,
        notificationChecked: this.notificationChecked
      })
    },
    handleClickResetPassword() {
      if (!validatePhoneNumber(this.phoneWithCountryCode)) {
        this.notifyInvalidPhoneNumber()
        return
      }
      if (!this.authCode) {
        this.showMessage(this.$t("auth.enterSMSCode"))
        return
      }
      if (!this.password) {
        this.showMessage(this.$t("auth.enterYourNewPassword"))
        return
      }
      if (!validatePassword(this.password)) {
        this.showMessage(this.$t("auth.passwordRule"))
        return
      }
      this.$emit("handleResetPassword", {
        phoneNumber: this.phoneWithCountryCode,
        code: this.authCode,
        password: this.password
      })
    },
    showMessage(message) {
      this.$message({
        message,
        type: "warning"
      })
    }
  }
}
